<template>
  <div>
<!--    <my-header />-->
    <div id="contentContainer" class="main-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// import MyHeader from '../components/custom-layout/MyHeader'

export default {
  name: 'CustomLayout',
  components: {
    // MyHeader
  }
}
</script>

<style scoped>
.main-body {
  width: 100%;
  height: calc(100vh - 110px);
  overflow-y: auto;
  background-color: var(--container-bg-color);
  padding: 0 20px 20px 20px;
  min-width: 375px;
}
@media only screen and (max-width: 768px) {
  .main-body {
    height: calc(100vh - 92px);
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/CustomLayout.vue